// src/i18n/en/lockerControllers.js
const lockerControllers = {
    name: 'Locker Controller |||| Locker Controllers',
    titles: {
        list: 'Locker Controllers',
        create: 'Create Locker Controller',
        edit: 'Edit Controller',
        show: 'Controller Details',
        details: 'View details'
    },
    fields: {
        name: 'Name',
        ipAddress: 'IP Address',
        tcpPort: 'TCP Port',
        macAddress: 'MAC Address',
        zone: 'Zone',
        hotel: 'Hotel',
        active: 'Active',
        isActive: 'Active',
        connection: 'Connection',
        connectionStatus: 'Connection Status',
        status: 'Status',
        network: 'Network',
        lockers: 'Lockers',
        lastSeen: 'Last Connection',
        createdAt: 'Created at',
        updatedAt: 'Last updated',
        firmware: 'Firmware',
        hardwareVersion: 'Hardware',
        lockerCount: 'Number of lockers',
        activeLockerCount: 'Active lockers'
    },
    labels: {
        controller_name: 'Controller Name',
        controller_info: 'Controller Information',
        network_config: 'Network Configuration',
        general_info: 'General Information',
        location: 'Location',
        network_info: 'Network Information',
        connection_stats: 'Connection Statistics',
        active_lockers: 'active',
        optional: '(Optional)',
        more_actions: 'More actions',
        last_connection: 'Last connection',
        connection_time: 'Time without connection',
        created: 'Created',
        updated: 'Updated',
        hardware_version: 'Hardware',
        mac_address: 'MAC'
    },
    status: {
        online: 'Online',
        offline: 'Offline',
        connected: 'Connected',
        disconnected: 'Disconnected',
        never_connected: 'Never connected',
        active: 'Active',
        inactive: 'Inactive',
        yes: 'Yes',
        no: 'No',
        never: 'Never'
    },
    search: {
        placeholder: 'Search...',
        zone_placeholder: 'Search by zone...'
    },
    filters: {
        search: 'Search',
        zone: 'Zone',
        status: 'Status',
        active: 'Active',
        inactive: 'Inactive'
    },
    actions: {
        create: 'Create Controller',
        edit: 'Edit',
        delete: 'Delete',
        archive: 'Archive',
        view: 'View details',
        show: 'View details',
        test_connection: 'Test connection',
        configure: 'Configure'
    },
    dialogs: {
        delete: {
            title: 'Delete Controller - %{name}',
            content: 'Are you sure you want to delete this controller?',
            confirm: 'Delete',
            cancel: 'Cancel'
        },
        delete_title: 'Delete Controller',
        delete_message: 'Are you sure you want to delete controller "%{name}"?',
        delete_warning_with_lockers: 'Controller "%{name}" has %{count} assigned locker. |||| Controller "%{name}" has %{count} assigned lockers.',
        delete_cascade_warning: 'This action will affect associated lockers.',
        test_connection: {
            title: 'Test Connection - %{name}',
            content: 'This will attempt to establish a TCP connection with the controller to verify its status.',
            confirm: 'Test Connection',
            cancel: 'Cancel',
            testing: 'Testing...'
        }
    },
    messages: {
        no_hotel_selected: 'No hotel selected',
        select_hotel_to_view: 'Select a hotel to view controllers',
        no_permission_create: 'Only SuperAdmins can create new locker controllers.',
        no_permission_edit: 'You do not have permission to edit controllers',
        no_permission_access: 'You do not have permission to access this page',
        no_permission_configure: 'No permission to modify',
        creation_success: 'Controller created successfully',
        update_success: 'Controller updated successfully',
        update_error: 'Failed to update controller',
        delete_success: 'Controller deleted successfully',
        delete_confirm: 'Are you sure you want to delete this controller?',
        deleted_successfully: 'Controller deleted successfully',
        delete_error: 'Error deleting controller',
        archive_confirm: 'Are you sure you want to archive this controller?',
        archived_successfully: 'Controller archived successfully',
        archive_error: 'Error archiving controller',
        test_connection_success: 'Connection established successfully',
        test_connection_failed: 'Failed to connect to controller',
        controller_online: 'Controller online',
        controller_offline: 'Controller offline',
        loading: 'Loading...',
        info_controller_management: 'A controller manages multiple physical lockers through a TCP/IP connection.',
        info_network_config: 'Make sure the controller is network accessible before creating it. You can test the connection after creation.',
        info_controller_offline_long: 'The controller has not reported a connection for over an hour. Check network connectivity and device status.',
        connection_warning: 'The controller has not reported a connection for over an hour. Check network connectivity and device status.',
        has_associated_lockers: 'This controller has %{count} associated locker. |||| This controller has %{count} associated lockers.'
    },
    warnings: {
        delete_irreversible: 'This action cannot be undone. The controller will be permanently deleted.',
        controller_online_delete: '⚠️ The controller is currently online. It is recommended to disconnect it before deleting.',
        delete_consequences: 'Lockers associated with this controller may become inaccessible after this action.',
        unsaved_changes: 'You have unsaved changes. Are you sure you want to leave?',
        network_connectivity: 'Make sure the controller is network accessible before creating it. You can test the connection after creation.'
    },
    errors: {
        controller_in_use: 'Controller is in use',
        has_lockers: 'Controller has assigned lockers',
        creation_failed: 'Failed to create controller',
        update_failed: 'Failed to update controller',
        delete_failed: 'Failed to delete controller',
        load_failed: 'Failed to load data',
        permission_denied: 'You do not have permission to perform this action',
        connection_failed: 'Failed to connect to controller'
    },
    help: {
        name: 'Descriptive name for the controller (e.g., Zone A Controller)',
        ip_address: 'Controller IP address (IPv4 or IPv6)',
        tcp_port: 'TCP port for communication',
        mac_address: 'Format: XX:XX:XX:XX:XX:XX',
        zone: 'Zone where the controller is physically located',
        zone_optional: 'Zone (Optional)',
        active: 'Disable if controller is out of service'
    },
    validation: {
        name_required: 'Controller name is required',
        name_min_length: 'Name must be at least 2 characters',
        name_max_length: 'Name cannot be more than 100 characters',
        ip_required: 'IP address is required',
        ip_invalid: 'Invalid IP address format',
        port_required: 'TCP port is required',
        port_range: 'Port must be between 1 and 65535',
        hotel_required: 'Hotel is required',
        zone_required: 'Zone is required',
        mac_invalid: 'Invalid MAC address format'
    },
    tooltips: {
        last_connection: 'Last connection: %{date}',
        test_connection: 'Test connection',
        controller_actions: 'Actions for controller %{name}',
        minutes_ago: '%{minutes} minutes ago',
        hours_ago: '%{hours} hours ago',
        days_ago: '%{days} days ago',
        online_status: 'Status: Online',
        offline_status: 'Status: Offline'
    },
    time: {
        minutes: 'minutes',
        hours: 'hours',
        days: 'days',
        ago: 'ago'
    },
    ui: {
        network_configuration: 'Network Configuration',
        connected: 'Connected',
        disconnected: 'Disconnected',
        ip_address: 'IP Address',
        tcp_port: 'TCP Port',
        mac_address: 'MAC Address',
        connection_status: 'Connection Status',
        connection_stats: 'Connection Statistics',
        last_connection: 'Last connection:',
        connection_time: 'Time without connection:',
        never: 'Never',
        online_status: 'Status: Online',
        minutes_ago: '%{minutes} minutes ago',
        offline_warning: 'The controller has been offline for over an hour. Check network connectivity and device status.',
        edit_title: 'Edit Locker Controller'
    },
    notifications: {
        load_controller_error: 'Error loading controller',
        connection_success: 'Connection successful',
        connection_failed: 'Could not connect to controller',
        test_connection_error: 'Error testing connection',
        controller_deleted_success: 'Controller deleted successfully',
        controller_delete_error: 'Error deleting controller',
    }
};

export default lockerControllers;
